export const apiStatus = {
  SUCCESS: 200,
  SEARCH_OVER: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
  ACCESS_FORBIDEN: 403,
  CONFLICT: 409,
  NO_AUTH: 401,
  NOT_FOUND: 404,
}
